export default {
  data() {
    return {
      // Define default options for select filters
      templatesOptions: [],
      contactsOptions: [],
      usersOptions: [],
      statusOptions: [],
      tagsOptions: [],
      localesOptions: [],
      themesOptions: [],
      timeColumnsOptions: [
        { label: this.$t("filters.created_at"), value: "created_at" },
        { label: this.$t("filters.updated_at"), value: "updated_at" },
        { label: this.$t("filters.last_active_at"), value: "last_active_at" },
      ],
      relativeTimeOptions: [
        { label: this.$t("filters.timeRelative.today"), value: "today" },
        {
          label: this.$t("filters.timeRelative.yesterday"),
          value: "yesterday",
        },
        {
          label: this.$t("filters.timeRelative.last_week"),
          value: "last_week",
        },
        {
          label: this.$t("filters.timeRelative.last_month"),
          value: "last_month",
        },
        {
          label: this.$t("filters.timeRelative.last_year"),
          value: "last_year",
        },
        { label: this.$t("filters.timeRelative.custom"), value: "custom" },
      ],
      customFieldOptions: {},
    };
  },
  methods: {
    // set options to appropriate filter in filters Object
    setFilterOptions() {
      this.getOptionsFromApi();
      this.filters.forEach((filter) => {
        if (filter.select) {
          if (filter.select.name === "with_template" || filter.select.name === "without_template") {
            filter.select.options = this.templatesOptions;
          }
          if (filter.select.name === "with_contact" || filter.select.name === "without_contact") {
            filter.select.options = this.contactsOptions;
          }
          if (filter.select.name === "with_user" || filter.select.name === "without_user") {
            filter.select.options = this.usersOptions;
          }
          if (filter.select.name === "with_status" || filter.select.name === "without_status") {
            filter.select.options = this.statusOptions;
          }
          if (filter.select.name === "with_tag" || filter.select.name === "without_tag") {
            filter.select.options = this.tagsOptions;
          }
          if (filter.select.name === "with_locale" || filter.select.name === "without_locale") {
            filter.select.options = this.localesOptions;
          }
          if (filter.select.name === "with_theme" || filter.select.name === "without_theme") {
            filter.select.options = this.themesOptions;
          }
          if (filter.select.name === "time_col") {
            filter.select.options = this.timeColumnsOptions;
          }
          if (filter.select.name === "time_relative") {
            filter.select.options = this.relativeTimeOptions;
          }
          if (filter.select.name === "with_type") {
            filter.select.options = this.templateSnippetsTypeOptions;
          }
          if (this.projectsCustomFields) {
            Object.keys(this.projectsCustomFields).forEach((key) => {
              if (this.projectsCustomFields[key].filterable) {
                if (filter.select.name === "with_custom_" + key || filter.select.name === "without_custom_" + key) {
                  filter.select.options = this.customFieldOptions[key];
                }
              }
            });
          }
        }
      });
    },
    // Set options from api loaded data
    getOptionsFromApi() {
      if (this.templates) {
        this.templates.forEach((template) => {
          this.templatesOptions.push({
            label: template.name,
            value: template.uid,
          });
        });
      }
      if (this.contacts) {
        this.contacts.forEach((contact) => {
          const name = this.$h.formatName(contact);
          this.contactsOptions.push({ label: name, value: contact.uid });
        });
      }
      if (this.users) {
        this.users.forEach((user) => {
          const name = this.$h.formatName(user);
          this.usersOptions.push({ label: name, value: user.uid });
        });
      }
      if (this.projectsStati) {
        Object.keys(this.projectsStati).forEach((key) => {
          if (this.projectsStati[key].bit > 4) {
            const title = this.projectsStati[key].title[this.teams[this.$route.params.team].account.locale]
              ? this.projectsStati[key].title[this.teams[this.$route.params.team].account.locale]
              : this.projectsStati[key].title.default;
            this.statusOptions.push({ label: title, value: key });
          }
        });
      }
      if (this.teamTags) {
        this.teamTags.forEach((tag) => {
          this.tagsOptions.push({ label: tag.name, value: tag.name });
        });
      }
      if (this.teamLanguages) {
        this.teamLanguages.forEach((lang) => {
          this.localesOptions.push({
            label: this.$t('lang["' + lang + '"]'),
            value: lang,
          });
        });
      }
      if (this.teamThemes) {
        this.teamThemes.forEach((theme) => {
          this.themesOptions.push({ label: theme.name, value: theme.uid });
        });
      }
      if (this.projectsCustomFields) {
        Object.keys(this.projectsCustomFields).forEach((key) => {
          if (this.projectsCustomFields[key].filterable) {
            let label;
            let options = [];
            this.projectsCustomFields[key].config.options.forEach((option) => {
              option.label[this.teams[this.$route.params.team].account.locale]
                ? (label = option.label[this.teams[this.$route.params.team].account.locale])
                : (label = option.label.default);
              options.push({ label: label, value: option.value });
            });
            this.customFieldOptions[key] = options;
          }
        });
      }
    },
    setCustomFilters(list) {
      if (this.projectsCustomFields) {
        Object.keys(this.projectsCustomFields).forEach((key) => {
          if (this.projectsCustomFields[key].filterable) {
            let newWithOption = {
              label: this.projectsCustomFields[key].title[this.teams[this.$route.params.team].account.locale]
                ? this.$t("filters.with") +
                  " " +
                  this.projectsCustomFields[key].title[this.teams[this.$route.params.team].account.locale]
                : this.$t("filters.with") + " " + this.projectsCustomFields[key].title.default,
              select: {
                custom: true,
                name: "with_custom_" + key,
                multiple: true,
                model: [],
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectCustom"),
                wrap: true,
                searchable: true,
                searchChange: () => {},
              },
              checkbox: true,
              hideIfNoOptions: true,
            };
            this.$set(newWithOption, "active", false);
            let newWithoutOption = {
              label: this.projectsCustomFields[key].title[this.teams[this.$route.params.team].account.locale]
                ? this.$t("filters.without") +
                  " " +
                  this.projectsCustomFields[key].title[this.teams[this.$route.params.team].account.locale]
                : this.$t("filters.without") + " " + this.projectsCustomFields[key].title.default,
              select: {
                custom: true,
                name: "without_custom_" + key,
                multiple: true,
                model: [],
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectCustom"),
                wrap: true,
                searchable: true,
                searchChange: () => {},
              },
              checkbox: true,
              hideIfNoOptions: true,
            };
            this.$set(newWithoutOption, "active", false);
            this.addCustomFilterToListsettings({
              list,
              customFilter: "with_custom_" + key,
            });
            this.addCustomFilterToListsettings({
              list,
              customFilter: "without_custom_" + key,
            });
            const index = this.filters.length - 3;
            this.filters.splice(index, 0, newWithoutOption);
            this.filters.splice(index, 0, newWithOption);
          }
        });
      }
    },
    initFilters(list) {
      this.filters.forEach((filter) => {
        if (filter.switch && filter.switch.name && !filter.select) {
          filter.active =
            this.teamsSettings[this.$route.params.team].listsSettings[list].filter[filter.switch.name].active;
          filter.switch.model =
            this.teamsSettings[this.$route.params.team].listsSettings[list].filter[filter.switch.name].model;
        }
        if (filter.select && !filter.select.custom) {
          filter.active =
            this.teamsSettings[this.$route.params.team].listsSettings[list].filter[filter.select.name].active;
          if (filter.filterGroup)
            this.filterDropdown[0].groups[filter.filterGroup].active =
              this.teamsSettings[this.$route.params.team].listsSettings[list].filter[filter.select.name].active;
          filter.select.model = this.transformValuesToModel(
            this.teamsSettings[this.$route.params.team].listsSettings[list].filter[filter.select.name].model,
            filter.select.name
          );
          if (
            !this.transformValuesToModel(
              this.teamsSettings[this.$route.params.team].listsSettings[list].filter[filter.select.name].model,
              filter.select.name
            ) &&
            filter.select.preselectModel
          )
            filter.select.model = filter.select.preselectModel;
        }
        if (filter.select && filter.select.custom) {
          this.teamsSettings[this.$route.params.team].listsSettings[list].customFilters.forEach((obj, key) => {
            if (obj.name === filter.select.name) {
              filter.active = this.teamsSettings[this.$route.params.team].listsSettings[list].customFilters[key].active;
              filter.select.model = this.transformValuesToModel(
                this.teamsSettings[this.$route.params.team].listsSettings[list].customFilters[key].model,
                filter.select.name,
                key
              );
            }
          });
        }
        if (filter.dateTimeRange) {
          let model = [];
          filter.dateTimeRange.name.forEach((field) => {
            model.push(new Date(this.teamsSettings[this.$route.params.team].listsSettings[list].filter[field].model));
          });
          filter.dateTimeRange.model = model;
        }
      });
    },
    transformValuesToModel(values, select) {
      let res = [];
      if (select === "with_template" || select === "without_template") {
        values.forEach((value) => {
          this.templates.forEach((template) => {
            if (template.uid === value) {
              res.push({ label: template.name, value: template.uid });
            }
          });
        });
      }
      if (select === "with_user" || select === "without_user") {
        values.forEach((value) => {
          this.users.forEach((user) => {
            if (user.uid === value) {
              res.push({
                label: user.first_name + " " + user.last_name,
                value: user.uid,
              });
            }
          });
        });
      }
      if (select === "with_contact" || select === "without_contact") {
        values.forEach((value) => {
          this.contacts.forEach((contact) => {
            if (contact.uid === value) {
              res.push({
                label: contact.first_name + " " + contact.last_name,
                value: contact.uid,
              });
            }
          });
        });
      }
      if (select === "with_status" || select === "without_status") {
        values.forEach((value) => {
          let title = "";
          switch (value) {
            case "ARCHIVED":
              title = this.$t("stati.status.title");
              break;
            case "POSTED":
              title = this.$t("stati.sent.title");
              break;
            case "VISITED":
              title = this.$t("stati.views.title");
              break;
            case "UPLOADS":
              title = this.$t("stati.uploads.title");
              break;
            case "DOWNLOADS":
              title = this.$t("stati.downloads.title");
              break;
            default:
              title = this.projectsStati[value].title[this.teams[this.$route.params.team].account.locale]
                ? this.projectsStati[value].title[this.teams[this.$route.params.team].account.locale]
                : this.projectsStati[value].title.default;
          }
          res.push({ label: title, value: value });
        });
      }
      if (select === "with_tag" || select === "without_tag") {
        values.forEach((value) => {
          this.teamTags.forEach((tag) => {
            if (tag.name === value) {
              res.push({ label: tag.name, value: tag.name });
            }
          });
        });
      }
      if (select === "with_locale" || select === "without_locale") {
        values.forEach((value) => {
          this.teamLanguages.forEach((lang) => {
            if (lang === value) {
              res.push({ label: this.$t('lang["' + lang + '"]'), value: lang });
            }
          });
        });
      }
      if (select === "time_col") {
        return values.length > 0 ? { label: this.$t("filters." + values), value: values } : null;
      }
      if (select === "time_relative") {
        return values.length > 0 ? { label: this.$t("filters.timeRelative." + values), value: values } : null;
      }
      if (
        select.split("_").slice(0, 2).join("_") === "with_custom" ||
        select.split("_").slice(0, 2).join("_") === "without_custom"
      ) {
        values.forEach((value) => {
          if (this.projectsCustomFields) {
            Object.keys(this.projectsCustomFields).forEach((key) => {
              if (this.projectsCustomFields[key].filterable && key === select.split("_").slice(2).join("_")) {
                let label;
                this.projectsCustomFields[key].config.options.forEach((option) => {
                  option.label[this.teams[this.$route.params.team].account.locale]
                    ? (label = option.label[this.teams[this.$route.params.team].account.locale])
                    : (label = option.label.default);
                  if (option.value === parseInt(value)) {
                    res.push({ label, value });
                  }
                });
              }
            });
          }
        });
      }
      return res;
    },
    setFilterRequestObjectFromStore(list, params) {
      this.filters.forEach((filter) => {
        if (filter.switch && filter.switch.name && !filter.select) {
          if (this.teamsSettings[this.$route.params.team].listsSettings[list].filter[filter.switch.name].active) {
            params[filter.switch.name] =
              this.teamsSettings[this.$route.params.team].listsSettings[list].filter[filter.switch.name].model;
          }
        }
        if (filter.select && !filter.select.custom) {
          if (this.teamsSettings[this.$route.params.team].listsSettings[list].filter[filter.select.name].active) {
            params[filter.select.name] =
              this.teamsSettings[this.$route.params.team].listsSettings[list].filter[filter.select.name].model;
          }
        }
        if (filter.select && filter.select.custom) {
          this.teamsSettings[this.$route.params.team].listsSettings[list].customFilters.forEach((obj, key) => {
            if (obj.name === filter.select.name) {
              if (this.teamsSettings[this.$route.params.team].listsSettings[list].customFilters[key].active) {
                if (!params[filter.select.name.split("_").slice(0, 2).join("_")])
                  params[filter.select.name.split("_").slice(0, 2).join("_")] = [];
                this.teamsSettings[this.$route.params.team].listsSettings[list].customFilters[key].model.forEach(
                  (val) => {
                    params[filter.select.name.split("_").slice(0, 2).join("_")].push(
                      filter.select.name.split("_").slice(2).join("_") + "." + val
                    );
                  }
                );
              }
            }
          });
        }
        if (filter.dateTimeRange) {
          filter.dateTimeRange.name.forEach((field) => {
            params[field] = this.teamsSettings[this.$route.params.team].listsSettings[list].filter[field].model;
          });
        }
      });
      return params;
    },
    transformModelToValues(model, customFieldName = false) {
      if (model.value) {
        return model.value;
      } else {
        let res = [];
        model.forEach((value) => {
          if (typeof value === "object" && value !== null) {
            if (customFieldName) {
              res.push(customFieldName + "." + value.value);
            } else {
              res.push(value.value);
            }
          } else {
            res.push(value);
          }
        });
        return res;
      }
    },
    resetFilters(apiCall, list = null) {
      this.filters.forEach((filter) => {
        filter.active = false;
        if (filter.switch && filter.switch.name) filter.switch.model = true;
        if (filter.select) filter.select.model = [];
        if (filter.select && filter.select.preselectModel) filter.select.model = filter.select.preselectModel;
        if (filter.dateTimeRange) filter.dateTimeRange.model = [];
      });
      if (this.filters.groups) {
        Object.keys(this.filters.groups).forEach((key) => {
          this.filters.groups[key].active = false;
        });
      }
      apiCall();
      if (list) {
        // @TODO check if needed
        this.setCurrentFilterPresetHasChanged({ list, state: false });
        this.setCurrentFilterPreset({ list, filterPreset: null });
      }
    },
  },
};
